<template>
  <div class="main fit row wrap justify-center items-center content-center">
    <div class="row " style="padding: 0px;">
<span class="col-auto self-center">
<ul><b>What is this page for? It's a bulk actions UI for assets transfer from CEX exchanges to external wallets</b></ul>
</span>
</div>
</div>
</template>

<script>
</script>

<style>

.main
{
  font-family: Inter, ui-sans-serif,system-ui, Helvetica ,Arial, sans-serif,"Apple Color Emoji","Segoe UI Emoji", Symbol,"Noto Color Emoji";
  font-size: 14px;
  font-weight: bold;
}
a:link {text-decoration: none;}
   a:hover {color: khaki;}
   a:visited {color: #1d1d1d; }
</style>